import api from './axiosConfig';

export type NetworkStatusValue =
  | 'NoNetwork'
  | 'NetworkNoInternet'
  | 'InternetAvailable'
  | 1
  | 2
  | 3;

export interface NetworkStatusResponse {
  status: NetworkStatusValue;
  message: string;
  isInternetAvailable?: boolean;
  checkedAtUtc?: string;
}

export const networkApi = {
  getStatus: async () => {
    const response = await api.get<NetworkStatusResponse>('/network/status', {
      timeout: 5000,
    });

    return response.data;
  },
};
